import Endpoints from "api/endpoints"
import generic from "api/call-deserialize"

export default class PricingService {
  static index = {
    key: () => Endpoints.guests.pricing.index.url,
    handler: () =>
      generic({
        apiEndpoint: Endpoints.guests.pricing.index,
      }),
  }
}
